export const reportCodes = {
  CreditMemo: 'CREDIT_MEMO',
  PriceQuote: 'PQ_REPORT',
  BVPriceQuote: 'BV_PQ_REPORT',
  BVCustomPriceQuote: 'BV_CUSTPQ_REPORT',
  JobReport: 'WEB_JO_ENV_BAILEY_OTHER_CUST',
}
